module.exports = __webpack_public_path__ + "static/media/help.dff8a795.svg";